(() => {
    if (window.cardProductSwatchesBound) return;
    window.cardProductSwatchesBound = true;
  
    function updateCard(swatch) {
      const card = swatch.closest('.product-card-wrapper');
      if (!card) return;
  
      const variantId = swatch.dataset.variantId;
      const variantUrl = swatch.dataset.variantUrl;
      const available =
        swatch.dataset.variantAvailable === 'true';
  
      const swatches = card.querySelectorAll(
        '[data-card-swatch]'
      );
  
      swatches.forEach((item) => {
        const selected = item === swatch;
  
        item.classList.toggle(
          'is-selected',
          selected
        );
  
        item.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
  
      const primaryImage = card.querySelector(
        '.card-media .media > img:first-child'
      );
  
      if (
        primaryImage &&
        swatch.dataset.imageSrc
      ) {
        primaryImage.src =
          swatch.dataset.imageSrc;
  
        if (swatch.dataset.imageSrcset) {
          primaryImage.srcset =
            swatch.dataset.imageSrcset;
        }
  
        if (swatch.dataset.imageWidth) {
          primaryImage.width = Number(
            swatch.dataset.imageWidth
          );
        }
  
        if (swatch.dataset.imageHeight) {
          primaryImage.height = Number(
            swatch.dataset.imageHeight
          );
        }
  
        primaryImage.alt =
          swatch.dataset.imageAlt ||
          primaryImage.alt;
      }
  
      if (variantUrl) {
        card
          .querySelectorAll(
            'a.full-unstyled-link'
          )
          .forEach((link) => {
            link.href = variantUrl;
          });
  
        card
          .querySelectorAll(
            '.quick-add__submit[data-product-url]'
          )
          .forEach((button) => {
            button.dataset.productUrl =
              variantUrl;
          });
      }
  
      const priceTemplate =
        swatch.querySelector(
          'template[data-card-swatch-price]'
        );
  
      const priceTarget = card.querySelector(
        '[data-card-product-price]'
      );
  
      if (priceTemplate && priceTarget) {
        priceTarget.replaceChildren(
          priceTemplate.content.cloneNode(true)
        );
      }
  
      const variantInput = card.querySelector(
        'product-form input[name="id"]'
      );
  
      const addButton = card.querySelector(
        'product-form .quick-add__submit'
      );
  
      if (variantInput && variantId) {
        variantInput.value = variantId;
        variantInput.disabled = !available;
      }
  
      if (addButton) {
        addButton.disabled = !available;
  
        const defaultText =
          addButton.querySelector(
            'span:not(.sold-out-message)'
          );
  
        const soldOutText =
          addButton.querySelector(
            '.sold-out-message'
          );
  
        if (defaultText && soldOutText) {
          defaultText.classList.toggle(
            'hidden',
            !available
          );
  
          soldOutText.classList.toggle(
            'hidden',
            available
          );
        }
      }
  
      card.dataset.selectedVariantId =
        variantId || '';
    }
  
    document.addEventListener(
      'click',
      (event) => {
        const swatch = event.target.closest(
          '[data-card-swatch]'
        );
  
        if (!swatch) return;
  
        event.preventDefault();
        updateCard(swatch);
      }
    );
  
    document.addEventListener(
      'mouseover',
      (event) => {
        const swatches =
          event.target.closest(
            '.card-product-swatches'
          );
  
        if (!swatches) return;
  
        const card = swatches.closest(
          '.product-card-wrapper'
        );
  
        if (!card) return;
  
        card.classList.add(
          'is-swatches-hovered'
        );
      }
    );
  
    document.addEventListener(
      'mouseout',
      (event) => {
        const swatches =
          event.target.closest(
            '.card-product-swatches'
          );
  
        if (!swatches) return;
  
        if (
          event.relatedTarget &&
          swatches.contains(
            event.relatedTarget
          )
        ) {
          return;
        }
  
        const card = swatches.closest(
          '.product-card-wrapper'
        );
  
        if (!card) return;
  
        card.classList.remove(
          'is-swatches-hovered'
        );
      }
    );
  })();